export interface ICorrelationParams {
  correlationId?: string;
  parentActionType?: string;
}
